import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { CouponInput } from '@fff-web/fff-payments';
import { RecurlyProvider, Elements } from '@recurly/react-recurly';
import env from 'pages/MyAccount/utils/env';
import './styles.css';

const CouponSelector = ({
  plan,
  onApplyCoupon,
  couponsApplied,
  error,
  initialCouponCode,
  onRemoveCoupon,
  customStyles,
  inputLabel,
  setCouponError,
}) => {
  const [isOpen, setIsOpen] = useState(!!initialCouponCode);
  useEffect(() => {
    setIsOpen(!!initialCouponCode);
  }, [initialCouponCode])

  const toggleIsOpen = () => setIsOpen(!isOpen);
  const handleApply = ({ coupon, price }) => {
    const discount = price && price.now && price.now.discount ? price.now.discount : 0;
    onApplyCoupon(coupon, discount);
  };
  const wrapperStyles = cx('coupon-selector', customStyles);

  const onCleanUpInput = (code) => {
    const findCoupon = couponsApplied.find((coupon) => coupon.code === code)
    if (findCoupon) {
      onRemoveCoupon(code)
      setIsOpen(false)
      // This setTimeout is to refresh the coupon input to remove the coupon code
      // The coupon code need to be refactored to has a callback to remove the coupon code
      setTimeout(() => {
        setIsOpen(true)
      }, 0)
    }
  }

  return (
    <RecurlyProvider publicKey={env.recurlyPublicKey}>
      <section className={wrapperStyles}>
        <div className={cx('coupon-selector__form', { 'is-open': isOpen })}>
          <button type="button" onClick={toggleIsOpen}>
            {inputLabel}
          </button>
          {isOpen && (
            <Elements>
              <CouponInput
                plan={plan}
                onApply={handleApply}
                error={error}
                initialCouponCode={initialCouponCode}
                onRemoveCoupon={onRemoveCoupon}
                onCallbackError={setCouponError}
              />
            </Elements>
          )}
        </div>
        {couponsApplied.length > 0 && (
          <div className="coupon-selector__applied">
            {couponsApplied.map(({ message, code }) => (
              <div key={message} className="coupon-selector__applied__coupon">
                <p className="title correct">
                  {message}
                </p>
                <i
                  className="fas fa-times close"
                  onClick={() => onCleanUpInput(code)}
                  onKeyPress={() => onCleanUpInput(code)}
                />
              </div>
            ))}
          </div>
        )}
      </section>
    </RecurlyProvider>
  );
};

CouponSelector.defaultProps = {
  onApplyCoupon: () => { },
  error: {},
  couponsApplied: [],
  initialCouponCode: null,
  plan: null,
  customStyles: null,
  inputLabel: 'Got a Coupon Code?'
};

CouponSelector.propTypes = {
  onApplyCoupon: PropTypes.func,
  error: PropTypes.shape({
    message: PropTypes.string,
  }),
  customStyles: PropTypes.string,
  couponsApplied: PropTypes.arrayOf(PropTypes.objectOf({
    message: PropTypes.string,
    code: PropTypes.string,
    type: PropTypes.string,
  })),
  initialCouponCode: PropTypes.string,
  plan: PropTypes.string,
};

export default CouponSelector;
